(function (window, document) {
  'use strict';

  if (window.ImpactTrackingBridge && window.ImpactTrackingBridge.version) {
    return;
  }

  function getTracking() {
    return window.StorefrontTracking || window.ProtoArcTracking || null;
  }

  function cleanObject(source) {
    var output = {};

    Object.keys(source || {}).forEach(function (key) {
      var value = source[key];

      if (value === null || typeof value === 'undefined') return;
      if (Array.isArray(value) && value.length === 0) return;
      output[key] = value;
    });

    return output;
  }

  function toNumber(value) {
    if (typeof value === 'number' && !isNaN(value)) return value;
    if (typeof value === 'string' && value.trim() !== '') {
      var parsed = Number(value);
      if (!isNaN(parsed)) return parsed;
    }

    return null;
  }

  function centsToAmount(value) {
    var numericValue = toNumber(value);

    if (numericValue === null) return null;
    if (String(numericValue).indexOf('.') !== -1) return numericValue;

    return Math.round(numericValue) / 100;
  }

  function buildTrackingItem(item) {
    if (!item) return null;

    var variantId = item.variant_id || item.id;
    var productId = item.product_id;
    var itemPrice = centsToAmount(item.final_price);

    if (itemPrice === null) itemPrice = centsToAmount(item.price);
    if (itemPrice === null) itemPrice = centsToAmount(item.original_price);

    return cleanObject({
      item_id: variantId != null ? String(variantId) : null,
      item_variant_id: variantId != null ? String(variantId) : null,
      product_id: productId != null ? String(productId) : null,
      sku: item.sku || null,
      item_name: item.product_title || item.title || null,
      item_brand: item.vendor || null,
      item_category: item.product_type || item.type || null,
      item_variant: item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : null,
      price: itemPrice,
      quantity: toNumber(item.quantity) || 1
    });
  }

  function buildTrackingItems(items) {
    return (Array.isArray(items) ? items : []).map(buildTrackingItem).filter(Boolean);
  }

  function computeItemsValue(items) {
    return items.reduce(function (sum, item) {
      var price = toNumber(item.price) || 0;
      var quantity = toNumber(item.quantity) || 1;
      return sum + (price * quantity);
    }, 0);
  }

  function getTrackingContext() {
    var tracking = getTracking();
    return (tracking && tracking.context) || window.__TRACKING_CONTEXT__ || {};
  }

  function syncProductContext(item) {
    var context = window.__TRACKING_CONTEXT__;

    if (!context || !context.ecommerce) return;

    context.page_type = 'product';
    context.ecommerce.items = item ? [item] : [];
    context.ecommerce.value = item && typeof item.price !== 'undefined' ? item.price : context.ecommerce.value;

    if (context.cart && !Array.isArray(context.cart.items)) {
      context.cart.items = [];
    }
  }

  function bindVariantAdded() {
    document.addEventListener('variant:add', function (event) {
      var tracking = getTracking();
      if (!tracking) return;

      var detail = event && event.detail ? event.detail : {};
      var cart = detail.cart || {};
      var items = buildTrackingItems(detail.items);

      if (!items.length) return;

      tracking.trackAddToCartSuccess({
        source: 'impact_variant_add',
        items: items,
        value: computeItemsValue(items),
        cart_item_count: toNumber(cart.item_count),
        cart_total_value: centsToAmount(cart.total_price)
      });
    });
  }

  function bindVariantChanged() {
    document.addEventListener('variant:change', function (event) {
      var tracking = getTracking();
      if (!tracking) return;

      var detail = event && event.detail ? event.detail : {};
      var variant = detail.variant || {};
      var baseContext = getTrackingContext();
      var baseItem = ((baseContext.ecommerce && baseContext.ecommerce.items) || [])[0] || {};
      var variantId = variant && typeof variant.id !== 'undefined' ? String(variant.id) : null;
      var variantPrice = centsToAmount(variant.price);

      if (!variantId) return;

      var nextItem = cleanObject({
        item_id: variantId,
        item_variant_id: variantId,
        product_id: baseItem.product_id || (variant.product_id != null ? String(variant.product_id) : null),
        sku: variant.sku || baseItem.sku || null,
        item_name: baseItem.item_name || variant.name || null,
        item_brand: baseItem.item_brand || null,
        item_category: baseItem.item_category || null,
        item_variant: variant.title && variant.title !== 'Default Title' ? variant.title : null,
        price: variantPrice !== null ? variantPrice : baseItem.price,
        quantity: 1
      });

      syncProductContext(nextItem);

      tracking.track('view_item', cleanObject({
        source: 'impact_variant_change',
        items: [nextItem],
        value: nextItem.price
      }), {
        onceKey: 'view_item:' + window.location.pathname + ':variant:' + variantId
      });
    });
  }

  function bindB2BLeadSuccess() {
    var sent = false;

    function maybeTrackLeadSuccess() {
      if (sent) return;

      var tracking = getTracking();
      var form = document.getElementById('b2bForm');
      var successBox = document.getElementById('mySuccessBox');

      if (!tracking || !form || !successBox) return;

      var computedStyle = window.getComputedStyle ? window.getComputedStyle(successBox) : null;
      var isVisible = successBox.style.display !== 'none' && (!computedStyle || computedStyle.display !== 'none');

      if (!isVisible) return;

      sent = true;

      var productInterestField = form.querySelector('[name="contact[Product interest]"]');
      var estimatedQuantityField = form.querySelector('[name="contact[Estimated quantity]"]');

      tracking.trackLeadSuccess(cleanObject({
        source: 'impact_b2b_success',
        lead_type: 'b2b_quote_request',
        form_id: 'b2bForm',
        form_name: 'b2b_quote_request',
        resource: 'b2b_quote_form',
        resource_id: 'b2bForm',
        product_interest: productInterestField ? productInterestField.value : null,
        estimated_quantity: estimatedQuantityField ? estimatedQuantityField.value : null
      }));
    }

    function initLeadObserver() {
      var form = document.getElementById('b2bForm');
      var successBox = document.getElementById('mySuccessBox');

      if (!form || !successBox) return;

      form.addEventListener('submit', function () {
        window.setTimeout(maybeTrackLeadSuccess, 0);
        window.setTimeout(maybeTrackLeadSuccess, 500);
        window.setTimeout(maybeTrackLeadSuccess, 1500);
      });

      if (typeof MutationObserver === 'function') {
        var observer = new MutationObserver(maybeTrackLeadSuccess);
        observer.observe(successBox, {
          attributes: true,
          attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
        });
      }

      maybeTrackLeadSuccess();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initLeadObserver);
    } else {
      initLeadObserver();
    }
  }

  function init() {
    bindVariantAdded();
    bindVariantChanged();
    bindB2BLeadSuccess();

    /*
      Impact begin_checkout mapping does not need extra JS here.
      tracking-core.js already listens for:
      - button[name="checkout"]
      - input[name="checkout"]
      - a[href*="/checkout"]
      - [data-track-begin-checkout]

      b2bForm / mySuccessBox are Impact pilot implementation details.
      They are intentionally kept inside this bridge instead of becoming
      part of the cross-brand tracking standard.
    */
  }

  window.ImpactTrackingBridge = {
    version: '1.0.0'
  };

  init();
})(window, document);
